module.exports = __webpack_public_path__ + "static/media/fast-forward.831014f1.svg";